import { useEffect } from "react";
import queryString from "query-string";
import { config } from "node-config-ts";
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

export const useDataDog = () => {
    const initializeDataDogLogsAndRum = (samplingRate: number) => {
        datadogLogs.init({
            clientToken: 'pub7f40882be54b9490ddb126e2fd6638cb',
            site: 'datadoghq.com',
            version: process.env.REACT_APP_VERSION,
            env: config.APPLICATION_ENVIRONMENT,
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
            service: 'dcui-v4'
        });

        datadogRum.init({
            applicationId: '552e9d81-0cf6-48e7-a8fb-6af29e712a8d',
            clientToken: 'pub7f40882be54b9490ddb126e2fd6638cb',
            site: 'datadoghq.com',
            version: process.env.REACT_APP_VERSION,
            env: config.APPLICATION_ENVIRONMENT,
            service: 'dcui-v4',
            sessionSampleRate: 10,
            sessionReplaySampleRate: samplingRate,
            startSessionReplayRecordingManually: true,
            trackUserInteractions: true,
            allowedTracingUrls: [
                /https:\/\/.*\.iddataweb\.com/,
                /https:\/\/.*\.iddataweb\.io/
            ]
        });
    };

    const beginDataDogSession = () => {
        const query = location.search || window.location.search;
        const queryParameters = queryString.parse(query, { decode: true }) as { [key: string]: string };

        let samplingRate = 0;
        if (queryParameters.samplingRate && !isNaN(parseInt(queryParameters.samplingRate))) {
            samplingRate = parseInt(queryParameters.samplingRate);
        }

        initializeDataDogLogsAndRum(samplingRate);

        datadogLogs.setGlobalContextProperty('asi', queryParameters.token);
        datadogRum.setGlobalContextProperty('asi', queryParameters.token);
        datadogRum.setUser({
            id: queryParameters.token,
            asi: queryParameters.token
        });

        datadogRum.startSessionReplayRecording();
    };

    useEffect(() => {
        beginDataDogSession();
    }, []);
};